import React from 'react';
import Head from '../head/Head';
import ClosedShell from '../components/shop/ClosedShell';
import NewsletterForm from '../components/NewsletterForm';
import { useSiteContact } from '../hooks/useSiteContact';

export const COMING_SOON_TITLE = 'Hamarosan — GT Kreatív Sarok';

/** Zárt bolt mód: ezt látja a látogató, amíg a tulaj fel nem tölti és meg nem nyitja a
 *  boltot. Az elérhetőségek a Beállításokból jönnek; hiányzó adat nem jelenik meg. */
const ComingSoonPage: React.FC = () => {
  const { phone, phoneHref, email, emailHref } = useSiteContact();
  return (
    <ClosedShell>
      <Head title={COMING_SOON_TITLE} meta={[{ name: 'robots', content: 'noindex, nofollow' }]} />
      <section className="gtsoon-hero">
        <img src="/brand/logo-mark.svg" alt="GT Kreatív Sarok" />
        <div className="gtsoon-flag">Hamarosan</div>
        <h1>Hamarosan nyitunk!</h1>
        <p>
          Már készül a webshopunk: pólók, bögrék, táskák és ajándékok egyedi nyomattal, egy darabtól.
          Addig is szívesen segítünk telefonon vagy e-mailben.
        </p>
        {(phone || email) && (
          <div className="gtsoon-contact">
            {phone && <a href={phoneHref}>{phone}</a>}
            {email && <a href={emailHref}>{email}</a>}
          </div>
        )}
        <div className="gtsoon-news">
          <h2>Szólunk, amikor nyitunk</h2>
          <p>Iratkozz fel a hírlevelünkre — a megerősítő levélben lévő linkre kattintva leszel feliratkozó.</p>
          <NewsletterForm variant="compact" source="home" />
        </div>
      </section>
    </ClosedShell>
  );
};

export default ComingSoonPage;
